import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Input, Button, Row, Col, Form, DatePicker, Select, Divider } from "antd";
import moment from "moment";
import * as Yup from "yup";
import { useFormik } from "formik";

import { DataTable } from './components';
import PageTitle from '../../_components/PageTitle';
import reportingDashboardActions from '../../_actions/reportingDashboard.actions';
import CountCard from '../../_components/CountCard';
import CanAccess from '../../_components/CanAccess';
import ErrorPage from '../../_components/ErrorPage';
import { formatNumber } from '../../_helpers/utils';

const { RangePicker } = DatePicker;
const { Option } = Select;
const ReportingDashboard = () => {
	const dispatch = useDispatch();
	const { getAllReports, getFilteredReports, getFilteredSummaryCount } =
		reportingDashboardActions;
	const [startDate, setStartDate] = useState('');
	const [endDate, setEndDate] = useState('');
	const [page, setPage] = useState(1);

	const handleReset = (page) => {
		setStartDate();
		setEndDate();
		resetForm();
		setPage(1);
		dispatch(getAllReports(1));
	};

	// const user = useSelector((state) => state.currentUserState.currentUser);

	const handleRangeChange = (dates) => {
    setFieldValue("startDate", `${dates[0].format("YYYY-MM-DD")} 00:00:00`);
    setFieldValue("endDate", `${dates[1].format("YYYY-MM-DD")} 23:59:59`);
	};

	const getInitialFilters = () => {
		return {};
	};

	const {
		values,
		errors,
		handleChange,
		handleSubmit,
		setFieldValue,
		resetForm,
	} = useFormik({
		initialValues: getInitialFilters(),
		validationSchema: Yup.object({
			status: Yup.string(),
			caseId: Yup.string(),
			terminalId: Yup.string(),
			startDate: Yup.string(),
			endDate: Yup.string(),
		}),
		onSubmit() {
			fetchData(1);
		},
	});

	const fetchData = (page) => {
		const filters = {
			pageNumber: page,
			...values,
		};
		setPage(page);

		const countFilters = {
			...values,
		};

		if (!values.status) delete values.status;
		if (!values.caseId) delete values.caseId;
		if (!values.terminalId) delete values.terminalId;
		if (!values.startDate) delete values.startDate;
		if (!values.endDate) delete values.endDate;

		dispatch(getFilteredReports(10, filters));
		dispatch(getFilteredSummaryCount(countFilters));
	};

	// const {
	// 	reportCount,
	// 	isGetAllReportsLoading,
	// } = useSelector((state) => state.reportsState);

	const { countLoading, countSummary, filteredCountSummary } = useSelector(
		(state) => state.reportingDashboardCountState
	);

	const { total, totalSuccess, totalFailed, totalPending, totalUnprocessed } =
		countSummary;

	return (
		// <CanAccess
		//   role={user}
		//   perform="DASHBOARD_VIEW"
		//   yes={() => (
		<div>
			<PageTitle>Reporting Dashboard</PageTitle>
			<div className="filter__container">
				<Row gutter={[16, 16]} type="flex" justify="space-between">
					<Col
						sm={{ span: 24 }}
						lg={{ span: 24 }}
						xl={{ span: 24 }}
						xxl={{ span: 24 }}
					>
						<Row gutter={[16, 16]} type="flex" justify="start">
							<Col sm={12} md={12} lg={12} xl={8} xxl={8}>
								<Form.Item>
									<label>Case ID:</label>
									<Input
										placeholder="Case ID"
										name="caseId"
										allowClear={true}
                        onChange={(e) =>
                          setFieldValue("caseId", e.target.value)
                        }
										value={values.caseId}
									/>
								</Form.Item>
							</Col>
							<Col sm={12} md={12} lg={12} xl={8} xxl={8}>
								<Form.Item>
									<label>Terminal ID:</label>
									<Input
										placeholder="Terminal ID"
										name="terminalId"
										allowClear={true}
										onChange={(e) =>
                          setFieldValue("terminalId", e.target.value)
										}
										value={values.terminalId}
									/>
								</Form.Item>
							</Col>
							<Col sm={12} md={12} lg={12} xl={8} xxl={8}>
								<Form.Item>
									<label>Status:</label>
									<Select
										showSearch
                        style={{ width: "100%" }}
										allowClear={true}
										placeholder="Select a status"
										optionFilterProp="children"
                        onChange={(value) => setFieldValue("status", value)}
										value={values.status}
										filterOption={(input, option) =>
											option.children
												.toLowerCase()
												.indexOf(input.toLowerCase()) >= 0
										}
									>
										<Option value="SUCCESS">Success</Option>
										<Option value="PENDING">Pending</Option>
										<Option value="FAILED">Failed</Option>
										<Option value="UNPROCESSED">Unprocessed</Option>
									</Select>
								</Form.Item>
							</Col>
							<Col sm={24} md={24} lg={12} xl={8} xxl={8}>
								<Form.Item>
									<label>Date Range:</label>
									<RangePicker
                        style={{ width: "100%" }}
										allowClear={false}
										value={
											values.startDate && values.endDate
												? [moment(values.startDate), moment(values.endDate)]
												: []
										}
										onChange={handleRangeChange}
                        placeholder={["Start Date", "End Date"]}
										format="YYYY-MM-DD"
										separator="-"
									/>
								</Form.Item>
							</Col>
						</Row>
					</Col>
					<Col
						sm={{ span: 24 }}
						lg={{ span: 24 }}
						xl={{ span: 24 }}
						xxl={{ span: 24 }}
					>
						<Row type="flex" gutter={[16]}>
							<Col>
								<Button type="primary" onClick={handleSubmit}>
									Apply
								</Button>
							</Col>
							<Col>
								<Button onClick={() => handleReset(1)}>Clear</Button>
							</Col>
						</Row>
					</Col>
				</Row>
			</div>
			<Divider />
			<div style={{ marginBottom: '3rem', marginTop: '3rem' }}>
				<CountCard
					totalCountTitle="Total Registration"
					totalCountContent={
						Object.keys(values).length !== 0
						? formatNumber(filteredCountSummary.total)
						: formatNumber(total)
					}
					totalSuccessCountTitle="Successful"
					totalSuccessCountContent={
						Object.keys(values).length !== 0
							? formatNumber(filteredCountSummary.totalSuccess)
							: formatNumber(totalSuccess)
					}
					totalFailedCountTitle="Failed"
					totalFailedCountContent={
						Object.keys(values).length !== 0
							? formatNumber(filteredCountSummary.totalFailed)
							: formatNumber(totalFailed)
					}
					totalPendingCountTitle="Pending"
					totalPendingCountContent={
						Object.keys(values).length !== 0
							? formatNumber(filteredCountSummary.totalPending)
							: formatNumber(totalPending)
					}
					totalUnprocessedCountTitle="Unprocessed"
					totalUnprocessedCountContent={
						Object.keys(values).length !== 0
							? formatNumber(filteredCountSummary.totalUnprocessed)
							: formatNumber(totalUnprocessed)
					}
					loading={countLoading}
				/>
			</div>
			<DataTable filterValues={{ values }} page={page} setPage={fetchData} />
		</div>
		//   )}
		//   no={() => {
		//     return <ErrorPage />;
		//   }}
		// />
	);
};

export default ReportingDashboard;
